<div class="flex flex-row h-[700px] bg-base-200 text-base-content rounded-lg overflow-hidden border border-base-300">
  <!-- Fixed Navigation Sidebar -->
  <nav class="w-52 bg-base-300 p-4 flex flex-col shrink-0 h-full">
    <div class="text-sm font-semibold text-base-content/70 mb-2">Einstellungen</div>

    <!-- Scrollbare Nav-Items -->
    <div class="flex-1 overflow-y-auto space-y-1 min-h-0">
      <a *ngFor="let setting of PASettingsControl.Instance.settingTabs"
         (click)="scrollToSection(setting)"
         class="block px-3 py-2 rounded cursor-pointer text-sm transition-colors"
         [class.bg-primary]="PASettingsControl.Instance.activeSettingsTab === setting"
         [class.text-primary-content]="PASettingsControl.Instance.activeSettingsTab === setting"
         [class.hover:bg-base-100]="PASettingsControl.Instance.activeSettingsTab !== setting">
        {{setting}}
      </a>
    </div>

    <!-- Immer sichtbarer Speichern-Button -->
    <div class="pt-4 border-t border-base-content/10 shrink-0">
      <button class="bm-btn bm-btn-primary bm-btn-sm w-full"
              [disabled]="!PASettingsControl.Instance.settingsHaveChanged()"
              (click)="PASettingsControl.Instance.createOrUpdateSettingsInDatabase()">
        Als Standard speichern
      </button>
    </div>
  </nav>

  <!-- Scrollable Content Area -->
  <div #settingsContent class="flex-1 overflow-y-auto p-6 space-y-6" (scroll)="onScroll($event)">

    <!-- Section: Allgemein -->
    <section id="section-Allgemein" class="bm-card bm-card-border border-base-300 bg-base-100">
      <div class="bm-card-body">
        <h2 class="bm-card-title text-lg mb-4">Allgemein</h2>

        <!-- Wochentage -->
        <div class="mb-6">
          <label class="bm-fieldset-label mb-2">Wochentage ({{selectedWeekDaysToString()}})</label>
          <div class="bm-join">
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.monday"
                    (click)="toggleWeekday('mo')">Mo</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.tuesday"
                    (click)="toggleWeekday('di')">Di</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.wednesday"
                    (click)="toggleWeekday('mi')">Mi</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.thursday"
                    (click)="toggleWeekday('do')">Do</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.friday"
                    (click)="toggleWeekday('fr')">Fr</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.saturday"
                    (click)="toggleWeekday('sa')">Sa</button>
            <button type="button" class="bm-join-item bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="PASettingsControl.Instance.selectedSettingConfig.data.general.show_weekdays.sunday"
                    (click)="toggleWeekday('so')">So</button>
          </div>
        </div>

        <!-- Karte Optionen -->
        <div>
          <label class="bm-fieldset-label mb-2">Karten-Optionen</label>
          <div class="space-y-3">
            <label class="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" class="toggle toggle-primary toggle-sm"
                     [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.map.show_operation_times">
              <span class="text-sm">Zeige Auftragszeiten auf Karte</span>
            </label>
            <label class="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" class="toggle toggle-primary toggle-sm"
                     [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.map.seperated_tour_view">
              <span class="text-sm">
                {{PASettingsControl.Instance.selectedSettingConfig.data.general.map.seperated_tour_view ? 'Tourenansicht: Einzeln' : 'Tourenansicht: Kombiniert'}}
              </span>
            </label>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Planung -->
    <section id="section-Planung" class="bm-card bm-card-border border-base-300 bg-base-100">
      <div class="bm-card-body">
        <h2 class="bm-card-title text-lg mb-4">Planung</h2>

        <!-- Auftragsplanung -->
        <div class="mb-6">
          <label class="bm-fieldset-label mb-2">Auftragsplanung</label>
          <div class="flex flex-wrap items-center gap-4">
            <label class="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" class="toggle toggle-primary toggle-sm"
                     [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.operation_planning.show_close_technician_tours">
              <span class="text-sm">Zeige Techniker-Touren in der Nähe</span>
            </label>
            <label class="bm-input bm-input-sm w-40"
                   [class.opacity-50]="!PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.operation_planning.show_close_technician_tours">
              <span class="bm-label text-xs">km</span>
              <input type="number" min="0" class="w-16 text-right"
                     [disabled]="!PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.operation_planning.show_close_technician_tours"
                     [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.operation_planning.show_close_technician_tours_distance">
            </label>
          </div>
        </div>

        <!-- Zeit-Berechnungen -->
        <div>
          <label class="bm-fieldset-label mb-2">Zeit-Berechnungen</label>
          <label class="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" class="toggle toggle-primary toggle-sm"
                   [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.use_driving_time_factor">
            <span class="text-sm">Individueller Fahrtzeitfaktor</span>
          </label>
        </div>
      </div>
    </section>

    <!-- Section: Startzeiten -->
    <section id="section-Startzeiten" class="bm-card bm-card-border border-base-300 bg-base-100">
      <div class="bm-card-body">
        <h2 class="bm-card-title text-lg mb-4">Startzeiten</h2>

        <!-- Standard-Startzeit -->
        <div class="mb-6">
          <label class="bm-fieldset-label mb-2">Standard-Startzeit für Tourenberechnung</label>
          <div class="flex items-center gap-3">
            <input type="time"
                   class="bm-input bm-input-sm w-32"
                   [value]="getDefaultStartTimeString()"
                   (change)="onDefaultStartTimeChange($event)">
            <select class="bm-select bm-select-sm w-44"
                    [ngModel]="PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.work_start_times.default_is_arrival_time ? 'arrival' : 'departure'"
                    (ngModelChange)="PASettingsControl.Instance.selectedSettingConfig.data.tour_planning.work_start_times.default_is_arrival_time = $event === 'arrival'">
              <option value="departure">Losfahrzeit</option>
              <option value="arrival">Ankunftszeit</option>
            </select>
          </div>
        </div>

        <!-- Individuelle Techniker-Startzeiten -->
        <div>
          <label class="bm-fieldset-label mb-1">Individuelle Techniker-Startzeiten</label>
          <p class="text-xs text-base-content/60 mb-3">
            Techniker mit abweichender Startzeit. Alle anderen verwenden die Standard-Startzeit.
          </p>

          <div class="border border-base-300 rounded-lg overflow-hidden">
            <!-- Leere Liste -->
            <div *ngIf="getActiveTechnicianStartTimes().length === 0" class="p-4 text-sm text-base-content/50 text-center">
              Keine individuellen Startzeiten definiert.
            </div>

            <!-- Liste der Techniker -->
            <div *ngFor="let config of getActiveTechnicianStartTimes(); let last = last"
                 class="flex items-center gap-3 p-3"
                 [class.border-b]="!last"
                 [class.border-base-300]="!last">
              <span class="flex-1 text-sm">{{getTechnicianNameById(config.user_id)}}</span>
              <input type="time"
                     class="bm-input bm-input-sm w-28"
                     [value]="getTechnicianStartTimeString(config)"
                     (change)="onTechnicianStartTimeChange($event, config)">
              <select class="bm-select bm-select-sm w-44"
                      [ngModel]="config.is_arrival_time ? 'arrival' : 'departure'"
                      (ngModelChange)="config.is_arrival_time = $event === 'arrival' || undefined">
                <option value="departure">Losfahrzeit</option>
                <option value="arrival">Ankunftszeit</option>
              </select>
              <button class="bm-btn bm-btn-error bm-btn-sm bm-btn-square" (click)="removeTechnicianStartTime(config.user_id)">
                <span class="text-lg leading-none">&times;</span>
              </button>
            </div>

            <!-- Hinzufügen -->
            <div class="p-3 bg-base-200/50" [class.border-t]="getActiveTechnicianStartTimes().length > 0" [class.border-base-300]="getActiveTechnicianStartTimes().length > 0">
              <button *ngIf="!showAddTechnicianDialog"
                      class="bm-btn bm-btn-primary bm-btn-sm"
                      (click)="showAddTechnicianDialog = true">
                + Techniker hinzufügen
              </button>

              <!-- Hinzufügen-Dialog -->
              <div *ngIf="showAddTechnicianDialog" class="space-y-3">
                <div class="flex items-center gap-3">
                  <input type="text"
                         class="bm-input bm-input-sm flex-1"
                         placeholder="Techniker suchen..."
                         [(ngModel)]="technicianSearchFilter">
                  <label class="flex items-center gap-2 cursor-pointer shrink-0">
                    <input type="checkbox" class="toggle toggle-primary toggle-sm"
                           [(ngModel)]="onlyBentomaxTechnicians">
                    <span class="text-sm">Nur Bentomax</span>
                  </label>
                </div>

                <div class="max-h-48 overflow-y-auto border border-base-300 rounded bg-base-100">
                  <div *ngFor="let technician of getFilteredTechniciansForAdd()"
                       (click)="addTechnicianStartTime(technician.id)"
                       class="px-3 py-2 text-sm cursor-pointer hover:bg-primary/10 border-b border-base-200 last:border-b-0">
                    {{technician.getFullName()}}
                  </div>
                  <div *ngIf="getFilteredTechniciansForAdd().length === 0"
                       class="px-3 py-4 text-sm text-base-content/50 text-center">
                    Keine Techniker gefunden
                  </div>
                </div>

                <button class="bm-btn bm-btn-ghost bm-btn-sm"
                        (click)="showAddTechnicianDialog = false; technicianSearchFilter = ''">
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Reisetechniker -->
    <section id="section-Reisetechniker" class="bm-card bm-card-border border-base-300 bg-base-100">
      <div class="bm-card-body">
        <h2 class="bm-card-title text-lg mb-4">Reisetechniker</h2>

        <!-- Hotelübernachtung -->
        <div class="mb-6">
          <label class="bm-fieldset-label mb-2">Hotelübernachtung - Auftragsgenerierung</label>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Standard Priorität</label>
            <select class="bm-select bm-select-sm w-64"
                    [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.hotel_overnight_stay.default_priority_id">
              <option [ngValue]="null">-- Keine --</option>
              <option *ngFor="let priority of PADataControl.Instance.getProject(133)?.priorities || []" [ngValue]="priority.id">
                {{priority.name}}
              </option>
            </select>
          </fieldset>
        </div>

        <!-- Reiseziel Optimierung -->
        <div>
          <label class="bm-fieldset-label mb-2">Reiseziel Optimierung</label>
          <div class="flex flex-wrap items-center gap-4">
            <label class="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" class="toggle toggle-primary toggle-sm"
                     [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.active">
              <span class="text-sm">Automatisch optimieren</span>
            </label>
            <fieldset class="bm-fieldset"
                      [class.opacity-50]="!PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.active">
              <label class="bm-fieldset-label text-xs">An Wochentagen</label>
              <div class="flex flex-wrap gap-1">
                @for (weekday of PATimeControl.Instance.weekDays; track weekday) {
                  <label class="flex items-center gap-1.5 cursor-pointer text-xs px-2 py-1 rounded border border-base-300"
                         [class.bg-primary]="PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.on_weekdays.includes(weekday)"
                         [class.text-primary-content]="PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.on_weekdays.includes(weekday)"
                         [class.opacity-50]="!PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.active">
                    <input type="checkbox" class="hidden"
                           [disabled]="!PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.active"
                           [checked]="PASettingsControl.Instance.selectedSettingConfig.data.travel_technicians.optimize_travel_locations.on_weekdays.includes(weekday)"
                           (change)="toggleOptimizeWeekday(weekday)">
                    {{PATimeControl.Instance.weekDayToGermanName(weekday, true)}}
                  </label>
                }
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Rampups -->
    <section id="section-Rampups (extra Zeit)" class="bm-card bm-card-border border-base-300 bg-base-100">
      <div class="bm-card-body">
        <h2 class="bm-card-title text-lg mb-4">Rampups (extra Zeit)</h2>
        <hawk-additional-priority-time class="block"
                [technicians]="PAFilterControl.Instance.globalFilteredTechnicians"
                [projects]="PADataControl.Instance.loadedProjects"
                [config]="PASettingsControl.Instance.currentPriorityTimeRuleConfig">
        </hawk-additional-priority-time>
      </div>
    </section>

  </div>
</div>
